import PageNotFound from "./containers"

export default PageNotFound
